import style from './style.module.css'

const StatsBlock = () => {
  return (
    <div className={style.companyModal_stats}>
      <div className={style.companyModal_stats_item}>
        <span className={style.companyModal_stats_item_number}>10K+</span>
        <span className={style.companyModal_stats_item_currency}>
          employees
        </span>
      </div>

      <div className={style.companyModal_stats_item}>
        <span className={style.companyModal_stats_item_number}>2.8B</span>
        <span className={style.companyModal_stats_item_currency}>
          monthly users
        </span>
      </div>

      <div className={style.companyModal_stats_item}>
        <span className={style.companyModal_stats_item_number}>10K+</span>
        <span className={style.companyModal_stats_item_currency}>
          employees
        </span>
      </div>

      <div className={style.companyModal_stats_item}>
        <span className={style.companyModal_stats_item_number}>2.8B</span>
        <span className={style.companyModal_stats_item_currency}>
          monthly users
        </span>
      </div>
    </div>
  )
}

export default StatsBlock
